import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            backgroundColor: 'background.light',
            alignItems: ['center', 'center', 'center', 'unset'],
            justifyContent: ['center', 'center', 'center', 'unset'],
            flexShrink: [0, 0, 0, 'unset'],
            alignSelf: ['unset', 'unset', 'unset', 'stretch'],
            position: 'relative',
        },
        content: {
            display: 'flex',
            height: [remCalc(228), remCalc(228), remCalc(228), remCalc(80)],
            paddingY: `${remCalc(20)}`,
            // there should be another breakpoint with paddingX: 0
            // keeping it 'xlarge.base' for now due to the closeIcon
            paddingX: ['small.base', 'small.base', 'large.base', 'xlarge.base'],
            justifyContent: 'space-between',
            alignItems: ['flex-end', 'flex-end', 'flex-end', 'center'],
            flexShrink: 0,
            gap: [remCalc(16), remCalc(16), remCalc(16), 0],
            flexDirection: ['column', 'column', 'column', 'row'],
            maxWidth: 'container.xxl',
            width: '100%',
            mr: 'auto',
            ml: 'auto',
        },
        closeIcon: {
            width: [remCalc(24), remCalc(24), remCalc(24), remCalc(32)],
            height: [remCalc(24), remCalc(24), remCalc(24), remCalc(32)],
            color: 'background.brand',
            stroke: 'background.brand',
        },
        closeIconContainer: {
            display: 'flex',
            padding: [remCalc(4.8), remCalc(4.8), remCalc(4.8), remCalc(6)],
            justifyContent: ['center', 'center', 'center', 'flex-end'],
            alignItems: 'center',
            gap: remCalc(10),
            flexShrink: 0,
        },
        ctaContainer: {
            display: 'flex',
            flexDirection: ['column', 'column', 'column', 'unset'],
            justifyContent: ['center', 'center', 'center', 'flex-end'],
            alignItems: 'center',
            gap: [remCalc(16), remCalc(16), remCalc(16), remCalc(24)],
            alignSelf: ['stretch', 'stretch', 'stretch', 'unset'],
        },
        label: {
            textStyle: 'body-medium',
            color: 'text.default',
            alignSelf: ['stretch', 'stretch', 'stretch', 'unset'],
        },
        buttonIcon: {
            minWidth: '0',
            minHeight: '0',
        },
        blueButton: {
            width: ['100%', '100%', '100%', remCalc(216)],
            variant: 'primary',
        },
        whiteButton: {
            width: ['100%', '100%', '100%', remCalc(216)],
            variant: 'secondary',
        },
        blueButtonText: {
            flex: '1 0 0',
            textAlign: 'center',
            textStyle: 'body-medium',
        },
        whiteButtonText: {
            flex: '1 0 0',
            textAlign: 'center',
            textStyle: 'body-medium',
        },
        hideOnMobile: {
            display: {base: 'none', lg: 'flex'},
            position: 'absolute',
            right: remCalc(23),
        },
        hideOnDesktop: {
            display: {base: 'flex', lg: 'none'},
        },
    },
}
